// extracted by mini-css-extract-plugin
export default {"holderTopBar":"ConnexionModule_holderTopBar__yTRQv"};